import './Spinner.css';
import { PropTypes } from 'prop-types';

const Spinner = (props) => {
  const { agentTypingFlag, englishBot, size = 8 } = props;
  const messageContainer = document.getElementById('messageContainer');
  if (messageContainer) {
    messageContainer.scrollTop = messageContainer.scrollHeight - messageContainer.clientHeight;
  }
  const bounceStyle = {
    width: size,
    height: size,
  };
  return (
    <div className="spinner">
      {agentTypingFlag && (
        <span className="spinnerflag">{englishBot ? 'Typing' : 'escribiendo'}</span>
      )}
      <div className="bounce1" style={bounceStyle} />
      <div className="bounce2" style={bounceStyle} />
      <div className="bounce3" style={bounceStyle} />
    </div>
  );
};

Spinner.propTypes = {
  englishBot: PropTypes.bool,
  agentTypingFlag: PropTypes.bool,
  size: PropTypes.number,
};

export default Spinner;
